import React from 'react';
import * as Styled from './ShareButton.styled';
import { SocialLinks } from '../SocialLinks';
import { Modal } from '../../atoms/Modal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ShareButtonDataIds = {
  facebook: 'cp-share-button-facebook',
  instagram: 'cp-share-button-instagram',
  linkedin: 'cp-share-button-linkedin',
  twitter: 'cp-share-button-twitter',
  copyLink: 'cp-share-button-copy-link',
  email: 'cp-share-button-email',
  text: 'cp-share-button-sms'
};
export const ShareButtonModal = ({
  appealSet,
  cssBorderWidth,
  cssBorderColor,
  cssBackgroundColor,
  cssBackgroundColorOpacity,
  cssBorderRadius,
  cssColor,
  heading,
  isInstagramSharingEnabled,
  isMobileOrTablet,
  subheading,
  openLinksInNewTab,
  socialShareLinks,
  videoPreview,
  ariaLabelledById
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Modal.Header, {
    children: /*#__PURE__*/_jsx(Styled.ShareButtonModalTitle, {
      id: ariaLabelledById,
      children: heading
    })
  }), /*#__PURE__*/_jsxs(Styled.ShareButtonModalContent, {
    children: [/*#__PURE__*/_jsx("p", {
      children: subheading
    }), /*#__PURE__*/_jsx(SocialLinks, {
      appealSet: appealSet,
      cssBorderWidth: cssBorderWidth,
      cssBorderColor: cssBorderColor,
      cssBackgroundColor: cssBackgroundColor,
      cssBackgroundColorOpacity: cssBackgroundColorOpacity,
      cssColor: cssColor,
      cssBorderRadius: cssBorderRadius,
      isInstagramSharingEnabled: isInstagramSharingEnabled,
      isMobileOrTablet: isMobileOrTablet,
      openLinksInNewTab: openLinksInNewTab,
      socialShareLinks: socialShareLinks,
      videoPreview: videoPreview,
      dataIds: ShareButtonDataIds
    })]
  })]
});